import { EntityList } from '../../entityFramework/entityList/EntityList'

export const SubList = () => {
  return (<EntityList entity="SUB"/>)
}